import { Component, Input, ViewChild } from '@angular/core';
import type { AllDisplaysViewModel } from '../../../viewModels/all-displays-view-model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalComponent } from '../../../../../models/base/base-modal.component';
import { NewDisplay } from '../../../../../models/display/shared/new-display';
import { ReactiveFormGroupComponent } from '@mobilefirstdev/reactive-form';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-new-display-modal',
  templateUrl: './new-display-modal.component.html',
  styleUrls: ['./new-display-modal.component.scss'],
  standalone: false
})
export class NewDisplayModalComponent extends BaseModalComponent {
  constructor(protected activeModal: NgbActiveModal) {
    super(activeModal);
  }

  // View References
  @ViewChild('newDisplayInput') newDisplayInput: ReactiveFormGroupComponent;

  @Input() stickyCollectionKey: string = 'new-display-modal';

  // Display
  public viewModel: AllDisplaysViewModel;
  public newDisplay: NewDisplay = new NewDisplay();

  defaultSizes$ = window.types.digitalSizeTypes$;
  orientations$ = window.types.orientations$;
  // Form
  public canSubmitForm$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  override setupBindings() {
    const s = this.viewModel.dismissModalSubject.subscribe(display => {
      this.close(display);
    });
    this.pushSub(s);
  }
}
